import classNames from 'classnames'

import { ICON_COLOR, ICON_HEIGHT_16, IconNG } from '../../Icon'

import * as styles from './RentalPortalTimelineMarker.module.css'

import CheckmarkIcon from '../../../icons/checkmark.svg'

function RentalPortalTimelineMarker({ isDone, isLast, isLineDone }) {
  return (
    <div className={styles.RentalPortalTimelineMarker}>
      <div
        className={classNames(styles.circle, { [styles.circleDone]: isDone })}
      >
        {isDone ? (
          <IconNG
            Icon={CheckmarkIcon}
            color={ICON_COLOR.CurrentColor}
            size={ICON_HEIGHT_16}
          />
        ) : null}
      </div>
      {isLast ? null : (
        <div
          className={classNames(styles.line, {
            [styles.lineDone]: isLineDone,
          })}
        />
      )}
    </div>
  )
}

export default RentalPortalTimelineMarker
